import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultIllustrationInfo } from '../interfaces/IllustrationIf'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface C504IllustrationUpdateProps {
  execIllustrationUpdate: (
    illustrationId: string,
    text?: string,
    file_body?: File,
    full_file_body?: File,
    signed_url?: string,
  ) => Promise<ResultIllustrationInfo>
  loading: loadStatus
}
// C504 図解更新API呼出
export const useC504IllustrationUpdate = (): C504IllustrationUpdateProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildUrl } = useApiUrl()
  const execIllustrationUpdate = async (
    illustrationId: string,
    text?: string,
    file_body?: File,
    full_file_body?: File,
    signed_url?: string,
  ) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      let body = {}
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // console.log(header);

      // ボディ作成
      if (file_body) {
        body = {
          illustration_name: text,
          language: 'ja',
          file_name: file_body.name,
          url: signed_url,
        }
      } else if (full_file_body) {
        body = {
          illustration_name: text,
          language: 'ja',
          full_file_name: full_file_body.name,
          full_url: signed_url,
        }
      } else {
        body = { illustration_name: text, language: 'ja' }
      }

      // console.log(body);
      const response = await axios.put(
        `${buildUrl(apiUrl.illustrationsPath)}${illustrationId}`,
        body,
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execIllustrationUpdate, loading }
}
